import Section1 from "../components/aboutScreen/Section1";
import Section2 from "../components/aboutScreen/Section2";
import Section3 from "../components/aboutScreen/Section3";

export default function AboutPage() {
	return (
		<>
			<Section1 />

			<Section2 />
			<Section3 />
		</>
	);
}
